/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaVisibilityOff/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaVisibilityOff({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaVisibilityOff",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaVisibilityOff.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-OM5lD': alignSelf,'--mt-2-OM5lD': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-OM5lD': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-OM5lD': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-OM5lD': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-OM5lD': opacity,'--w-10-OM5lD': typeof width === 'number' ? `${width}px` : width,'--h-11-OM5lD': typeof height === 'number' ? `${height}px` : height,'--f-12-OM5lD': fill,'--a-7-OM5lD': isAnimated ? animation : "none",'--sd-8-OM5lD': isAnimated ? strokeDashoffset : 0,'--sd-9-OM5lD': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaVisibilityOff.SvgPath"
  data-view-path={viewPath}
 d="M15.725 13.525l-1.1-1.1c.433-1.183.208-2.167-.675-2.95-.883-.783-1.842-.983-2.875-.6l-1.1-1.1c.283-.183.6-.317.95-.4.35-.083.708-.125 1.075-.125 1.183 0 2.188.412 3.012 1.238.825.825 1.238 1.829 1.238 3.012 0 .367-.046.73-.137 1.088-.092.358-.221.67-.388.937zm3.225 3.225l-1-1c.817-.6 1.53-1.27 2.137-2.012.609-.742 1.055-1.488 1.338-2.238-.833-1.85-2.083-3.313-3.75-4.388C16.008 6.037 14.2 5.5 12.25 5.5c-.7 0-1.417.067-2.15.2-.733.133-1.308.292-1.725.475L7.225 5c.583-.267 1.33-.5 2.238-.7.908-.2 1.795-.3 2.662-.3 2.383 0 4.563.68 6.538 2.037 1.974 1.359 3.42 3.18 4.337 5.463a12.35 12.35 0 01-1.675 2.925 12.076 12.076 0 01-2.375 2.325zm1.45 5.65l-4.2-4.125a9.715 9.715 0 01-1.975.538C13.492 18.938 12.75 19 12 19c-2.433 0-4.642-.68-6.625-2.038C3.392 15.604 1.933 13.783 1 11.5c.333-.867.796-1.713 1.388-2.537A14.21 14.21 0 014.55 6.6L1.4 3.45l1.05-1.075L21.375 21.3l-.975 1.1zM5.575 7.65c-.617.45-1.213 1.042-1.788 1.775-.575.733-.987 1.425-1.237 2.075.85 1.85 2.13 3.313 3.838 4.387C8.095 16.962 10.033 17.5 12.2 17.5c.55 0 1.092-.033 1.625-.1.533-.067.933-.167 1.2-.3l-1.6-1.6a2.619 2.619 0 01-.675.188 4.869 4.869 0 01-.75.062 4.133 4.133 0 01-3-1.225c-.833-.817-1.25-1.825-1.25-3.025 0-.25.02-.5.063-.75.041-.25.104-.475.187-.675L5.575 7.65z"
 style={{'--f-12-OM5lD': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}